<template>
  <div class="bet-card-container">
    <div class="bet-card">
      <div class="bet-card-teams">
        <span v-html="betData.eventName"></span>
      </div>
      <div class="bet-card-result">
        <span class="bet-card-result-team"><span
          class="bet-card-result-text">{{betData.marketName}}</span>{{betData.runnerName.charAt(0).toUpperCase() + betData.runnerName.slice(1)}}</span></span>
      </div>
      <div class="bet-card-cells">
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             class="bet-card-cell bet-card-odds">
              <span v-if="betData.betType ==='lay'">{{ $t('bets.lay') |
              removeDiacriticsFromUppercase}}</span>
          <span v-if="betData.betType ==='back'">{{ $t('bets.back') |
              removeDiacriticsFromUppercase}}</span>
          <OddsInput
            :betData="betData"
            :betPosition="betPosition"
            inputSection="betslip"
            :type=type
            :alertId="alertId"
            :edit-mode="true"
          ></OddsInput>
        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             class="bet-card-cell bet-card-stake">
          <span>{{ $t('bets.stake') |
              removeDiacriticsFromUppercase}}</span>
          <StakeInput
            :betData="betData"
            :betPosition="betPosition"
            inputSection="betslip"
            @click.native="removeErrorMessageForStake(betData.runnerId)"
            :type=type
            :alertCase=alertCase
            :betSlipFirstTime="betSlipFirstTime"
            :edit-mode="true"
            :alertId="alertId"
          ></StakeInput>
        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             v-if="betData.betType === 'back'"
             class="bet-card-cell bet-card-profit">
          <span>{{ $t('bets.profit') |
              removeDiacriticsFromUppercase}}</span>
          <div class="bet-card-profit-value" v-if="profitForBet !==''&& profitForBet >= 0">
            {{profitForBet >=0 ? this.userCurrency :''}}{{profitForBet >=0 ?profitForBet : '' |
            numberWithCommas}}
          </div>
          <div class="bet-card-profit-value" v-if="profitForBet ==='' || profitForBet < 0">
          </div>
        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             v-if="betData.betType === 'lay'"
             class="bet-card-cell bet-card-profit">
          <span>{{ $t('bets.liability') |
              removeDiacriticsFromUppercase}}</span>
          <div class="bet-card-profit-value" v-if="liabilityForBet !=='' && liabilityForBet >= 0">
            {{liabilityForBet >=0 ? this.userCurrency :''}}{{liabilityForBet >=0 ?liabilityForBet :
            '' | numberWithCommas}}
          </div>
          <div class="bet-card-profit-value" v-if="liabilityForBet ==='' || liabilityForBet < 0">

          </div>
        </div>
        <div class="bet-card-cell bet-card-delete">
          <v-icon @click="removeBet">krypt-delete</v-icon>
        </div>
      </div>
    </div>
    <transition name="slide">
      <div v-if="alertCase !== ''" class="bet-alert">
        <transition name="fade">
          <span class="bet-alert-text">{{alertCase}}</span>
        </transition>
      </div>
    </transition>
  </div>

</template>

<script>
import OddsInput from '@/components/other/kryptOddsInput';
import StakeInput from '@/components/other/kryptStakesInput';
import DeleteIcon from '@/assets/utility/Delete.svg';

export default {
  name: 'betCard',
  props: [
    'type',
    'betData',
    'betPosition',
    'betSlipFirstTime'
  ],
  computed: {
    isPlacingBets: function () {
      return this.$store.state.bets.betslip.isPlacingBets;
    },
    profitForBet: function () {
      return ((Number(this.betData.odds) - 1) * Number(this.betData.stake)) !== 0 ? ((Number(this.betData.odds) - 1) * Number(this.betData.stake)).toFixed(2) : '0';
    },
    minimumLiability: function () {
      return this.$store.state.user.minimumLiability;
    },
    liabilityForBet: function () {
      return (this.betData.stake * (Number(this.betData.odds) - 1)) !== 0 ? (this.betData.stake * (Number(this.betData.odds) - 1)).toFixed(2) : '0';
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    userBalance: function () {
      return this.$store.state.user.info.balance;
    },
    alertId: function () {
      let messageId = '';

      messageId = this.$store.state.bets.betslip.betMessages[this.betData.refId]?.messageId || '';
      return messageId;
    },
    alertCase: function () {
      let message = '';
      if (this.runnerErrorMessage !== '') {
        message = this.runnerErrorMessage;
      } else if (this.marketErrorMessage !== '') {
        message = this.marketErrorMessage;
      } else {
        message = this.$store.state.bets.betslip.betMessages[this.betData.refId]?.message || '';
      }
      return message;
    },
    market: function () {
      return this.$store.state.markets[this.betData.eventId]?.markets[this.betData.marketId];
    },
    betRunner: function () {
      return (this.market ? this.market.runners.find((runner) => {
        return runner.id === this.betData.runnerId;
      }) : '');
    },
    marketStatus: function () {
      return this.market ? this.market.status : '-';
    },
    runnerIsActive: function () {
      return this.betRunner ? this.betRunner.active : false;
    }
  },
  watch: {
    marketStatus: function (marketStatus) {
      console.log(marketStatus);
      if (marketStatus === 'INACTIVE') {
        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'marketStatusMesage',
        //   message: this.$t('bets.errorMessages.marketInactive')
        // });
        this.marketErrorMessage = this.$t('bets.errorMessages.marketInactive');

        this.$store.commit('setBetIsValid', {
          position: this.betPosition,
          isValid: false,
          betType: this.betData.betType
        });

      } else if (marketStatus === 'SUSPENDED') {
        this.marketErrorMessage = this.$t('bets.errorMessages.marketSuspended');
        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'marketStatusMesage',
        //   message: this.$t('bets.errorMessages.marketSuspended')
        // });
        this.$store.commit('setBetIsValid', {
          position: this.betPosition,
          isValid: false,
          betType: this.betData.betType
        });

      } else {
        this.marketErrorMessage = '';
        this.$store.commit('setBetIsValid', {
          position: this.betPosition,
          isValid: true,
          betType: this.betData.betType
        });

      }
      if (marketStatus === '-') {
        this.removeBet();
      }
    },
    runnerIsActive: function (runnerIsActive) {
      console.log(runnerIsActive);
      if (runnerIsActive === false) {
        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'runnerStatusMessage',
        //   message: this.$t('bets.errorMessages.marketInactive')
        // });
        this.runnerErrorMessage = this.$t('bets.errorMessages.runnerInactive');
        this.$store.commit('setBetIsValid', {
          position: this.betPosition,
          isValid: false,
          betType: this.betData.betType
        });

      } else {
        this.runnerErrorMessage = '';
        this.$store.commit('setBetIsValid', {
          position: this.betPosition,
          isValid: true,
          betType: this.betData.betType
        });

      }
    }

  },
  data: function () {
    return {
      DeleteIcon: DeleteIcon,
      marketErrorMessage: '',
      runnerErrorMessage: ''
    };
  },
  methods: {
    removeErrorMessageForStake: function (betId) {
      this.$store.commit('removeErrorMessageForStake', betId);
    },
    removeBet: function () {
      this.$store.commit('removeBetFromBetSlip', {
        position: this.betPosition,
        betType: this.betData.betType,
        betId: this.betData.refId
      });
    },

  },
  components: {
    OddsInput,
    StakeInput
  },
  mounted() {
    if (this.marketStatus === 'INACTIVE') {

      this.marketErrorMessage = this.$t('bets.errorMessages.marketInactive');

      this.$store.commit('setBetIsValid', {
        position: this.betPosition,
        isValid: false,
        betType: this.betData.betType
      });

    } else if (this.marketStatus === 'SUSPENDED') {
      this.marketErrorMessage = this.$t('bets.errorMessages.marketSuspended');

      this.$store.commit('setBetIsValid', {
        position: this.betPosition,
        isValid: false,
        betType: this.betData.betType
      });

    } else if (this.runnerIsActive === false) {

      this.runnerErrorMessage = this.$t('bets.errorMessages.runnerInactive');
      this.$store.commit('setBetIsValid', {
        position: this.betPosition,
        isValid: false,
        betType: this.betData.betType
      });

    } else {

      this.marketErrorMessage = '';
      this.$store.commit('setBetIsValid', {
        position: this.betPosition,
        isValid: true,
        betType: this.betData.betType
      });
      this.runnerErrorMessage = '';
      this.$store.commit('setBetIsValid', {
        position: this.betPosition,
        isValid: true,
        betType: this.betData.betType
      });

    }

  }
};
</script>

<style scoped>

  .bet-card-container:not(:last-child) {
    border-bottom: solid 1px var(--grey-300);
  }

  .bet-card-container:last-child .bet-alert {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .bet-card {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding: 8px;
  }

  .bet-card-cells {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .bet-card-cell {
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    min-width: 80px;
    max-width: 80px;
  }

  .bet-card-cell > span {
    font-size: 10px;
    line-height: 14px;
    font-weight: bold;
    margin-bottom: 1px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bet-card-cell-back > span {
    color: var(--superman);
  }

  .bet-card-cell-lay > span {
    color: var(--lex-luthor);
  }

  .bet-card-teams {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-900);
    font-weight: bold;
    margin-bottom: 4px;
  }

  .bet-card-result {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 8px;
  }

  .bet-card-result-text {
    font-size: 14px;
    line-height: 19px;
    color: var(--grey-500);
    font-weight: normal;
    margin-right: 8px;
  }

  .bet-card-result-text::first-letter,
  .bet-card-result-team::first-letter,
  .bet-card-teams span::first-letter {
    text-transform: uppercase;
  }

  .bet-card-result-team {
    font-size: 14px;
    line-height: 19px;
    color: var(--grey-900);
    font-weight: bold;
  }

  .bet-card-delete {
    justify-content: flex-end;
    align-items: flex-end;
    min-width: 24px;
    max-width: 24px;
    margin-right: 0 !important;
    margin-left: 8px !important;
  }

  .bet-card-delete button {
    color: var(--grey-400);
    padding: 3px 0;
  }

  .bet-card-delete button:hover {
    color: var(--grey-600);
  }

  .bet-card-delete button:focus:after {
    opacity: 0 !important;
  }

  .bet-card-profit {
    flex-grow: 1;
    min-width: 0 !important;
    max-width: calc(100% - 176px) !important;
    overflow: hidden;
    margin-right: 0 !important;
  }

  .bet-card-profit > span {
    max-width: 80px;
  }

  .bet-card-profit-value {
    padding: 6px 4px;
    background-color: var(--grey-100);
    border-radius: 6px;
    overflow: hidden;
    width: max-content;
    max-width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    color: var(--primary);
    text-align: center;
    width: max-content;
    height: 28px;
    min-width: 80px;
  }

  .bet-card-odds {
    height: 100%;
  }

  .bet-card-stake {
    min-width: 80px !important;
    max-width: 80px !important;
  }

  .bet-alert {
    max-height: 64px;
    transition: max-height 0.5s ease-in-out;
    display: flex;
    align-items: center;
    background-color: var(--cyborg-light);
    clip-path: inset(0%);
  }

  .bet-alert-text {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--cyborg);
    padding: 8px;
  }


  .slide-enter-active, .slide-leave-active {
    transition: max-height 0.5s ease-in-out;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>
